import React, { useContext } from "react"
import { Page } from "@rubendenbrok/bloqmatter-cms"
import { DataContext } from "../Layout"
import DesktopHeader from "./DesktopHeader"
import MobileHeader from "./MobileHeader"

export default function Header() {
  return (
    <>
      <DesktopHeader />
      <MobileHeader />
    </>
  )
}
